/**
 * TourFeedback Component - Post-tour star rating and feedback form.
 * Shown inline for completed tours that don't yet have a buyer rating.
 */

import React, { useState } from 'react';
import styles from './TourFeedback.module.css';

const TourFeedback = ({ tourId, onSubmit }) => {
  const [rating, setRating] = useState(0);
  const [hovered, setHovered] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!rating) return;
    try {
      setSubmitting(true);
      setError(null);
      await onSubmit(tourId, rating, feedback);
    } catch (err) {
      setError('Failed to submit feedback. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.feedbackContainer}>
      <h4 className={styles.title}>How was your tour?</h4>
      <form onSubmit={handleSubmit}>
        <div className={styles.stars}>
          {[1, 2, 3, 4, 5].map((star) => (
            <button
              key={star}
              type="button"
              className={`${styles.star} ${star <= (hovered || rating) ? styles.starFilled : ''}`}
              onClick={() => setRating(star)}
              onMouseEnter={() => setHovered(star)}
              onMouseLeave={() => setHovered(0)}
              aria-label={`Rate ${star} star${star !== 1 ? 's' : ''}`}
            >
              ★
            </button>
          ))}
        </div>
        <textarea
          className={styles.feedbackText}
          placeholder="Share your experience (optional)"
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          rows={3}
          maxLength={1000}
        />
        {error && <p className={styles.error}>{error}</p>}
        <button
          type="submit"
          className={styles.submitBtn}
          disabled={!rating || submitting}
        >
          {submitting ? 'Submitting…' : 'Submit Feedback'}
        </button>
      </form>
    </div>
  );
};

export default TourFeedback;
